import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { type LessonPage, type Nullable, type SkillSetPage } from "../../../models"
import { css } from "vite-css-in-js"
import BootstrapButton from "../../../components/BootstrapButton"
import { computed, ref } from "vue"

interface Props {
   skillSet: SkillSetPage
   setPage(lesson?: LessonPage): void
}

const pageStyles = css`
   background-color: #D8EFEE;
   padding-top: 0.5rem;
   padding-bottom: 1rem;
`

const backButton = css`
   background-color: transparent;
   border: none;
   color: #00A89E;
   cursor: pointer;
   aspect-ratio: 1 / 1;
   padding: 0.75rem;
   border-radius:100%;
   transition: 0.2s;
   font-size: 20px;
   margin: 0 0.5rem;

   &:hover {
      background-color: #dddddd;
      transition: 0.2s;
   }
`

const filterOptions = css`
   display: flex;
   padding: 0.5rem 2rem;
   gap: 0.5rem;
   overflow-x: auto;

   button {
      border: none;
      background-color: #fff;
      padding: 1rem 1.5rem;
      border-radius: 40px;
      min-height: 50px;
      font-size: 16px;
      cursor: pointer;
      transition: 0.2s;
   }

   button:hover {
      background-color: #dddddd;
      transition: 0.2s;
   }

   button[data-selected="true"] {
      background-color: #00A89E;
      color: #fff;
      transition: 0.2s;
   }

`

const lessonCards = css`
   display: grid;
   gap: 1rem;
   grid-template-columns: 1fr 1fr;
   margin: 1rem 2rem;

   div{
      background-color: #fff;
      display: flex;
      /* aspect-ratio: 5 / 3; */
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 6rem 0.5rem;
      border-radius: 16px;
      font-size: 14px;
      transition: 0.2s;
      width: auto;
      cursor: pointer;
      text-align: center;
   }

   div:hover {
      background-color: #dddddd;
      transition: 0.2s;
   }

   img {
      max-height: 75px;
      max-width: 75px;
      height: auto;
      width: auto;
      margin-top: auto;
   }
`

const PWA: ReactiveComponent<Props> = (props) => {
   const tagFilter = ref<Nullable<string>>(null)
   const shownLessons = computed(() => tagFilter.value ? props.skillSet.properties.lessons.filter((l) => l.properties.tags?.includes(tagFilter.value!)) : props.skillSet.properties.lessons)
   const allTags = computed(() => new Set(props.skillSet.properties.lessons.flatMap((l) => l.properties.tags)))

	return () => (
      <div class={pageStyles}>
         <BootstrapButton class={backButton} color="decider" onClick={() => props.setPage()}><i class="fas fa-arrow-left" /></BootstrapButton>
         <div class={filterOptions}>
            <BootstrapButton color="decider" data-selected={tagFilter.value === null} onClick={() => tagFilter.value = null}>All</BootstrapButton>
            {Array.from(allTags.value).map((t) => (
               <BootstrapButton color="decider" data-selected={tagFilter.value === t} onClick={() => tagFilter.value = t}>{t}</BootstrapButton>
            ))}
         </div>
         <div class={lessonCards}>
            {shownLessons.value.map((l) => (
               <div key={l.id} onClick={() => props.setPage(l)}>
                  {l.properties.image && (
                     <img src={`https://pwa-admin.thedecider.org.uk${l.properties.image[0]?.url}`} alt={l.properties.image[0]?.name}/>
                  )}
                  <p>{l.name}</p>
               </div>
            ))}
         </div>
      </div>
	)
}
export default defineComponent(PWA, inferProps<Props>())